import bg from '../assets/bg.png';
import logo from '../assets/logo.png';
import overlaybg from '../assets/overlaybg.png';
import spoon from '../assets/spoon.svg';
import welcome from '../assets/welcome.jpg';
import sign from '../assets/sign.png';
import quote from '../assets/quote.png';
import rs from '../assets/rsLogo.png'
import rslanding1 from '../assets/rslanding1.jpg'
import rslanding3 from '../assets/rslanding3.jpg'
import masaBg from '../assets/masa-no-bg.png';
import knife from '../assets/knife.jpg';
import thanksgiving from '../assets/thanksgiving.jpg';
import rs_menu_bcg from '../assets/rs_menu_bcg.jpg';

 const images = {
  bg,
  rs_menu_bcg,
  rslanding3,
  rslanding1,
  knife,
  logo,
  overlaybg,
  spoon,
  welcome,
  sign,
  quote,
  rs,
  masaBg,
  thanksgiving,
};
export default images